export default __webpack_public_path__ + "static/media/expand-marker.aa91540b.svg";